import type { PropsWithChildren } from 'react';

import { Typography } from '../../components/typography';

export const ErrorMessage = ({ children }: PropsWithChildren) => (
  <Typography
    color="textSecondary"
    variant="codeBlock"
    sx={{ margin: '0 auto', whiteSpace: 'pre-line' }}
  >
    {children}
  </Typography>
);
